module.exports = __webpack_public_path__ + "static/media/empresa-banner.d3e35a36.jpg";